import { motion } from "framer-motion";

const easeOut = [0.16, 1, 0.3, 1];

export function useMotionOK() {
  const hasIO =
    typeof window !== "undefined" && typeof window.IntersectionObserver !== "undefined";
  return hasIO;
}

export const MotionSection = ({
  children,
  className,
  delay = 0,
  y = 26,
  once = false,
  ...props
}) => {
  const motionOK = useMotionOK();

  return (
    <motion.section
      className={className}
      {...props}
      initial={motionOK ? { opacity: 0, y } : false}
      whileInView={motionOK ? { opacity: 1, y: 0 } : undefined}
      viewport={motionOK ? { once, amount: 0.2 } : undefined}
      transition={motionOK ? { duration: 0.8, ease: easeOut, delay } : undefined}
    >
      {children}
    </motion.section>
  );
};

export const MotionStagger = ({
  children,
  className,
  delayChildren = 0.05,
  staggerChildren = 0.08,
  once = false,
  ...props
}) => {
  const motionOK = useMotionOK();

  return (
    <motion.div
      className={className}
      {...props}
      initial={motionOK ? "hidden" : false}
      whileInView={motionOK ? "show" : undefined}
      viewport={motionOK ? { once, amount: 0.2 } : undefined}
      variants={
        motionOK
          ? {
              hidden: { opacity: 0 },
              show: {
                opacity: 1,
                transition: { delayChildren, staggerChildren },
              },
            }
          : undefined
      }
    >
      {children}
    </motion.div>
  );
};

export const MotionItem = ({ children, className, y = 14 }) => {
  const motionOK = useMotionOK();

  return (
    <motion.div
      className={className}
      variants={
        motionOK
          ? {
              hidden: { opacity: 0, y },
              show: { opacity: 1, y: 0, transition: { ease: easeOut, duration: 0.6 } },
            }
          : undefined
      }
    >
      {children}
    </motion.div>
  );
};

export const MotionHover = ({ children, className, scale = 1.03 }) => {
  const motionOK = useMotionOK();

  return (
    <motion.div
      className={className}
      whileHover={motionOK ? { scale } : undefined}
      whileTap={motionOK ? { scale: 0.98 } : undefined}
      transition={motionOK ? { duration: 0.25, ease: easeOut } : undefined}
    >
      {children}
    </motion.div>
  );
};

